import { isValidElement } from "react"
import { useDialogInfo } from "@/hooks/use-dialog-info"

import {
  closeDialogInfo,
  selectIsDialogInfoOpen,
} from "@/lib/storage/dialog-slice"
import { useAppDispatch, useAppSelector } from "@/lib/storage/hooks"
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./ui/alert-dialog"

export function DialogInfo() {
  const dispatch = useAppDispatch()
  const dialogOpen = useAppSelector(selectIsDialogInfoOpen)
  const context = useDialogInfo()
  const handleOpenChange = (open: boolean) => {
    if (!open) {
      dispatch(closeDialogInfo())
    }
  }

  const isMessageElement = isValidElement(context?.message)

  return (
    <>
      {context && (
        <AlertDialog open={dialogOpen} onOpenChange={handleOpenChange}>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>{context.title}</AlertDialogTitle>
            </AlertDialogHeader>
            <AlertDialogDescription
              className="prose text-center text-pretty"
              render={isMessageElement ? <div /> : undefined}
            >
              {context.message}
            </AlertDialogDescription>
            <AlertDialogFooter>
              {context.cancelLabel && (
                <AlertDialogCancel onClick={context.cancelAction}>
                  {context.cancelLabel}
                </AlertDialogCancel>
              )}
              <AlertDialogAction
                onClick={context.okAction}
                variant={context.okVariant}
              >
                {context.okLabel || "OK"}
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      )}
    </>
  )
}
